angular.module('core')
  .service('teacherApi', ['$http', 'cancelableResourceFactory', 'cancelableResourceManager', '$state', 'nameFilter', 'highlightsApi', 'transformResponse', 'timeframe', 'exportService', '$filter', function ($http, $cancelableResourceFactory, $cancelableResourceManager, $state, $nameFilter, $highlightsApi, $transformResponse, $timeframe, $exportService, $filter) {
    var self = this;

    var teacherSettingsMapping = function(body) {
      try {
        if (body) {
          var teacher = JSON.parse(body);
          teacher.type = 'teacher';
          return teacher;
        }
        return null;
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var teacherProductSettingsMapping = function(body) {
      try {
        var teacher_product = JSON.parse(body);
        teacher_product.type = 'teacher_product';
        return teacher_product;
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var teacherNavigationMapping = function(teacher) {
      teacher.name = $nameFilter(teacher);
    };

    var schoolReportingMapping = function(teacher) {
      teacher.name = $nameFilter(teacher);
      teacher.activeStudents = teacher.count_active_students;
      teacher.averageMonthlySessionTime = teacher.average_monthly_session_time;
      teacher.extendedUsage = teacher.percent_usage_extended_hours;
      teacher.lessonsCompletedThisYear = teacher.count_lessons_completed;
      teacher.averageGrowth = teacher.percent_growth;
      return teacher;
    };

    var academicStandardsMapping = function(academic_standards) {};

    var TeacherSettings = $cancelableResourceFactory.createCacheableResource(null, '/m/teacher/:id/settings', {id: '@id'}, {
      get: {
        transformResponse: teacherSettingsMapping,
        url: '/m/teacher/:id/settings',
        method: 'GET'
      }
    });

    var TeacherProductSettings = $cancelableResourceFactory.createCacheableResource(null, '/m/teacher/:id/academic_standards', {id: '@id'}, {
      get: {
        transformResponse: teacherProductSettingsMapping,
        url: '/m/teacher/:id/settings',
        method: 'GET'
      }
    });

    var TeacherSessionSettings = $cancelableResourceFactory.createCacheableResource(null, '/e/session/school_admin_mode', {}, {});

    var TeacherNavigation = $cancelableResourceFactory.createCacheableResource('TeacherNavigation', '/n/districts/:districtId/teachers', {id: '@id'}, {
      query: {
        cache: true,
        url: '/n/districts/:districtId/teachers',
        method: 'GET',
        isArray: true,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationQuery('teacher', body, teacherNavigationMapping);
        }
      },

      get: {
        cache: true,
        url: '/n/districts/:districtId/teachers?teacher_id=:teacherId',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationGet('teacher', body, teacherNavigationMapping);
        }
      }
    });

    var teacherReportingUrl = '/r/districts/:districtId/teachers';

    var TeacherReporting = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/teachers', {id: '@id'}, {
      query: {
        url: teacherReportingUrl,
        method: 'GET',
        isArray: true,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformReportingQuery('teacher', body, schoolReportingMapping, status);
        }
      },
      getFrequency: {
        url: '/r/districts/:districtId/teachers/frequency',
        method: 'GET',
        cache: false,
        isArray: false,
        transformResponse: $transformResponse.transformResponseToJson
      }
    });

    var AcademicStandardsManagement = $cancelableResourceFactory.createCacheableResource('AcademicStandardsManagement', '/m/academic_standards', {id: '@id'},
        {
          query: {
            cache: true,
            url: '/m/academic_standards',
            method: 'GET',
            isArray: true,
            transformResponse: function(body) {
              return $transformResponse.transformGeographyQuery('academic_standard', body, academicStandardsMapping);
            }
          },
          get: {
            url: '/m/academic_standards',
            method: 'GET',
            isArray: true,
            transformResponse: function(body) {
              return $transformResponse.transformGeographyGet('academic_standard', body, academicStandardsMapping);
            }
          }
        });

    /**************************************************************/
    /*                          Api                               */
    /**************************************************************/

    var getTeachersReportingParams = function() {
      var params = _.pick($state.params, ['districtId', 'order', 'sort']);
      params.school_id = $state.params.schoolId || undefined;
      params.grade_id = $state.params.gradeId || undefined;
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      params.start = $state.current.data.page || undefined;
      return params;
    };

    self.getTeachersReportingExportUrl = function() {
      var params = getTeachersReportingParams();
      return $exportService.buildExportUrl(teacherReportingUrl, params);
    };

    self.getTeachersReporting = function() {
      var params = getTeachersReportingParams();
      var promises = TeacherReporting.query(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getTeachersFrequency = function() {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = $state.params.schoolId || undefined;
      params.grade_id = $state.params.gradeId || undefined;
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      var promises = TeacherReporting.getFrequency(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getTeachers = function(callback) {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = $state.params.schoolId || undefined;
      params.teacherId = $state.params.teacherId || undefined;
      var promises = TeacherNavigation.query(params);
      promises.$promise.then(callback);
    };

    self.getTeachersForGrade = function(school_id, grade_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = school_id;
      params.grade_id = grade_id;
      var promises = TeacherNavigation.query(params);
      promises.$promise.then(callback);
    };

    self.getTeachersForSchool = function(districtId, schoolId, callback) {
      var params = {
        districtId: districtId,
        school_id: schoolId
      };

      var promises = TeacherNavigation.query(params);
      promises.$promise.then(callback);
    };

    self.getTeacher = function(teacher_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.teacherId = teacher_id;
      var promises = TeacherNavigation.get(params);
      promises.$promise.then(callback);
    };

    // deprecated: use getTeacherHighlights
    self.getTeacherData = function(teacher_id, callback) {
      //TODO: Make request to highlights endpoint - in teacher
      var data = {};
      var params = _.pick($state.params, ['districtId']);
      params.teacher_id = teacher_id;
      params.sy = $timeframe.calculateCurrentReportingYear();

      $highlightsApi.TeacherHighlights.get(params).$promise.then(function(highlights) {
        data = _.extend(data, highlights);
        callback(data);
      });
    };

    self.getTeacherHighlights = function(params) {
      return $highlightsApi.TeacherHighlights.get(params).$promise.then(function(highlights) {
        // not sure why extend is needed here (copied from getTeacherData)
        return _.extend({}, highlights);
      });
    };

    /**************************************************************/
    /*                     Settings Api                           */
    /**************************************************************/

    self.buildTeacherName = function(teacher) {
      var name = teacher.first_name + ' ' + teacher.last_name;
      // http://redmine/redmine/issues/49823
      if (teacher.email_address) {
        name += ' - ' + teacher.email_address;
      }
      return  name;
    };

    self.getTeacherSettings = function(tid, success, error) {
      var teacherSettings = TeacherSettings.get({id: tid});
      teacherSettings.$promise.then(function(teacher) {
        teacher.type = 'teacher';
        success(teacher);
      });
      return teacherSettings;
    };

    self.getTeacherSettingsSubject = function (teacherId) {
      var teacherSettingsSubject = new Rx.Subject();

      var teacherSettingsResource = TeacherSettings.get({
        id: teacherId
      });

      teacherSettingsResource.$promise.then(function(teacher) {
        teacher.type = 'teacher';

        teacherSettingsSubject.onNext(teacher);
      },
      function (error) {
        teacherSettingsSubject.onError(error);
      });

      return teacherSettingsSubject;
    };

    self.saveTeacherSettings = function(item, success, error) {
      var teacher = new TeacherSettings(item);
      teacher.$save([], success, error);
    };

    self.getTeacherProductSettings = function(tid, success, error) {
      var teacherProductSettings = TeacherProductSettings.get({id: tid});
      teacherProductSettings.$promise.then(function(teacher_product) {
        teacher_product.type = 'teacher';
        success(teacher_product);
      });
      return teacherProductSettings;
    };

    self.saveTeacherProductSettings = function(item, success, error) {
      var teacher_product = new TeacherProductSettings(item);
      teacher_product.$save([], success, error);
    };

    self.saveTeacherSessionSettings = function(item, success, error) {
      var teacher_session = new TeacherSessionSettings(item);
      teacher_session.$save([], success, error);
    };

    self.getAcademicStandards = function(callback, academic_standard) {
      var promises = AcademicStandardsManagement.query({});
      promises.$promise.then(callback);
    };

    /**************************************************************/
    /*                         Customer Usage Api                 */
    /**************************************************************/
    function getSchoolCustomersUsageParams() {
      var params = _.pick($state.params, ['districtId', 'schoolId']);
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      params.untilNow = true;
      return params;
    }

    var teachersUsageReportingMapping = function(usageItem) {
        usageItem.status = null;
        usageItem.id = usageItem.customer.id;
        usageItem.customerId = usageItem.customer.id;
        usageItem.first_name = usageItem.customer.first_name;
        usageItem.last_name = usageItem.customer.last_name;
        usageItem.usage_time_per_session = usageItem.average_usage_time_in_min;
    };
    var teacherUsageReportingUrl = '/r/districts/:districtId/schools/:schoolId/customers/usage';
    var CustomerUsageReporting = $cancelableResourceFactory.createCacheableResource(null, teacherUsageReportingUrl, { }, {
      query: {
        url: teacherUsageReportingUrl,
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
            return $transformResponse.transformAggregationQuery('usage', body, teachersUsageReportingMapping, 'teacher');
        }
      }
    });

    self.getSchoolCustomersUsage = function() {
      var params = getSchoolCustomersUsageParams();
      var promises = CustomerUsageReporting.query(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getSchoolCustomersUsageExportUrl = function() {
      var params = getSchoolCustomersUsageParams();
      return $exportService.buildExportUrl(teacherUsageReportingUrl, params);
    };

  }]);
